import React from 'react';
import { NavLink } from "react-router-dom";


const Footer = (props) => {

    return (

        <footer>
            <img className="logo-footer zone-tel-masque" src="/assets/img/navbar-logo.png" alt="Court-Jus" />
            <p>© copyright 2024-2025 AWA 05 Tous droits réservés</p>
            <p><NavLink aria-label="CGU" title="Condition générale d'utilisation" to="/cgu">CGU</NavLink></p>
            <p><NavLink aria-label="Politique de confidentialité" title="Politique de confidentialité" to="/politique">PC</NavLink></p>
            <p><NavLink aria-label="Mentions légales" title="Mentions légales" to="/mentionslegales">ML</NavLink></p>
            {/* <p><a href="mailto:court.jus.asso@gmail.com" aria-label="contact" title="contact">Nous-contacter</a></p> */}
            <img className="logo-footer zone-tel-masque" src="/img/court_jus_logo.png" alt="Court-Jus" />
        </footer>

    )
}

export default Footer;